import { Dispatch } from 'redux';

import * as Actions from '../actions/mainMenu';
import AbstractScenario from './AbstractScenario';

/**
 * メインメニューシナリオファクトリ
 */
export default class MainMenuScenarioFactory {
	/**
	 * 表示可能メニュー取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchMenuModel(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process(arg: {}) {
				return this.read('tsq_common_menuModel').then(data => {
					const items: string[] = data.menuList;

					this.dispatch(Actions.setMainMenuItems({ items }));
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * セッション有効確認シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createCheckSession(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			public run = (arg: {}) => {
				return this.process(arg);
			};
			protected process(arg: {}) {
				return this.read('tsq_common_menuModel');
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/MainMenuScenarioFactory.ts